import { addDays, format, isSaturday, isSunday, startOfWeek } from 'date-fns';
import { uk } from 'date-fns/locale';
import { WeekMap } from 'pages/Week/types';
import { isActive, WEEK_DAYS_COUNT } from 'pages/Week/utils';
import { capitalize } from 'utils/string/capitalize';

export const useWeek = (date: Date) => {
  let currentDate = date;

  if (isSaturday(date)) {
    currentDate = addDays(date, 2);
  }
  if (isSunday(date)) {
    currentDate = addDays(date, 1);
  }

  const startDayOfWeek = startOfWeek(currentDate, { weekStartsOn: 1 });

  const week: WeekMap = {};

  for (let i = 0; i < WEEK_DAYS_COUNT; i++) {
    const key = addDays(startDayOfWeek, i);
    const localizedDay = format(key, 'eeee', { locale: uk });
    week[format(key, 'yyyy-MM-dd')] = {
      label: capitalize(localizedDay),
      day: format(key, 'd'),
      date: format(key, 'dd.MM.yyyy'),
      active: isActive(key),
    };
  }

  return { week, days: Object.keys(week) };
};
